module.exports = __webpack_public_path__ + "img/20190810114117768.17aabfe8.png";